import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,Menu,Grid, ListItemIcon, ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import {  IconButton } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useAuth } from "../../../AuthProvider";


import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';


const baseUrl=process.env.REACT_APP_API_BASE_URL
const ExistingStudentsList = () => {
  const navigate = useNavigate();
  const {oId,board,role,userId,pId}=useAuth();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // Original API data

  const [loading, setLoading] = useState(true);
  // const [selectedClass, setSelectedClass] = useState("Class-I");
  // const [selectedSection, setSelectedSection] = useState("Section-A"); // Default to SECTION-A
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");
  
  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
  const [interSelectedSection, setInterSelectedSection] = useState("Section-A");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");

  

  const [mode, setMode] = useState("scrolling"); // "scrolling" or "classSection"
  // console.log("selected mode :"+mode);
  const [sscClassSectionMap, setSscClassSectionMap] = useState({});
  const [hasFetchedOnce, setHasFetchedOnce] = useState(false); // new flag

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
  
  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };
  
  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  // const handleClose = () => {
  //   setExportAnchorEl(null);
  // };



  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
  console.log("Selected User:",UserId);


    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount




//fetch overall api

// useEffect(() => {
//   // ✅ Strong guard: only call API when UserId and oId are both truthy
//   if (UserId && oId) {
//     fetchGetAllTableData();
//   }
// }, [UserId, oId]);

const fetchGetAllTableData = async () => {
  // ✅ Optional double check — not strictly necessary if guarded in useEffect
  if (!UserId || !oId) return;

  setLoading(true);
  setHasFetchedOnce(false);

  try {
    const response = await fetch(
      `${baseUrl}/api/admissionDashBoard/getOverAllExistingStudents/${oId}/${UserId}`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch student data');
    }

    const data = await response.json();

    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error('Error fetching table data:', error);
  } finally {
    setLoading(false);
    setHasFetchedOnce(true);
  }
};




// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};


// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!UserId || !sscSelectedClass || !sscSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admissionDashBoard/getAllExistingStudents/${oId}/${UserId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      if (!selectedCourseType) {
        setSelectedCourseType(data[0] || "");
      }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!UserId || !selectedCourseType || !interSelectedClass || !interSelectedSection) {
    setFilteredData([]);
    setOriginalData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/admissionDashBoard/getAllExistingStudents/${oId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      setOriginalData(data);
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setOriginalData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here

// SSC: When selected class changes, update its sections
// useEffect(() => {
//   const updateSectionOptions = async () => {
//     try {
//       const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}`);
//       const data = await response.json();
//       if (response.ok && Array.isArray(data)) {
//         const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
//         if (selectedClassData) {
//           const sections = selectedClassData.sections.split(",");
//           setSscSectionOptions(sections);
//           setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
//         } else {
//           setSscSectionOptions([]);
//           setSscSelectedSection("");
//         }
//       }
//     } catch (error) {
//       console.error("Error updating SSC sections:", error);
//     }
//   };

//   if (board === "SSC" && sscSelectedClass) {
//     updateSectionOptions();
//   }
// }, [sscSelectedClass, board, oId]);

// INTERMEDIATE: When class or course type changes, update sections
useEffect(() => {
  const updateIntermediateSections = async () => {
    if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
      await fetchSectionsData();
    }
  };
  updateIntermediateSections();
}, [interSelectedClass, selectedCourseType, board]);





// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// Fetch Table Data whenever filters change
useEffect(() => {
  if (board === "SSC") {
    if (!sscSelectedClass || !sscSelectedSection) {
      setOriginalData([])
      setFilteredData([]);
      setLoading(false); // ✅ stop loading even if API not called
      return;
    }
    fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  } else if (board === "INTERMEDIATE") {
    if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
      setOriginalData([])
      setFilteredData([]);
      
      setLoading(false); // ✅ same here
      return;
    }
    fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  }
}, [UserId,board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);







  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await fetch(
  //         `${baseUrl}/api/admissionDashBoard/getAllExistingStudents/${oId}?romanNumberClass=${toRoman(selectedClass)}&sections=${selectedSection}`);
  //       const data = await response.json();
  //       if (Array.isArray(data)) {
  //         setOriginalData(data);
  //         setFilteredData(data);
  //       } else {
  //         setOriginalData([]);
  //         setFilteredData([]); // Set empty array if data is not an array
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data: ", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  
  //   fetchData();
  // }, [selectedClass, selectedSection]); // Re-fetch data when selected class or section changes
  


  useEffect(() => {
    if (!searchQuery) {
      setFilteredData(originalData); // Reset to original data if search query is empty
      return;
    }
  
    const result = originalData.filter((student) => {
      const searchTerm = searchQuery.toLowerCase();
      return (
        String(student.customAdmissionNumber).toLowerCase().includes(searchTerm) || // Add search by admission number
        String(student.surName).toLowerCase().includes(searchTerm) ||
        String(student.firstName).toLowerCase().includes(searchTerm) ||
        String(student.lastName).toLowerCase().includes(searchTerm) ||
        String(student.primaryContact).includes(searchTerm)
      );
    });
  
    setFilteredData(result);
  }, [searchQuery, originalData]);
  
  

  


const exportToExcel = () => {

  const isIntermediate = board === "INTERMEDIATE";
    const dynamicKey = isIntermediate ? "Year" : "Class";
  const processedData = filteredData.map(({ 
    customAdmissionNumber, admissionDate,course, romanNumberClass, sections, firstName, lastName, 
    gender, fathersFirstName, fathersLastName, mothersFirstName, mothersLastName, primaryContact 
  }) => ({
    AdmissionNumber: customAdmissionNumber,  
    AdmissionDate: admissionDate,  
    ...(isIntermediate ? { Course: course } : {}),
      [dynamicKey]: romanNumberClass,
    Section: sections,
    StudentName: `${firstName} ${lastName}`,
    Gender: gender,
    FatherName: `${fathersFirstName} ${fathersLastName}`,
    MotherName: `${mothersFirstName} ${mothersLastName}`,
    Phone: primaryContact,
  }));

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(
    board === "INTERMEDIATE"
      ? `${interSelectedClass}-${interSelectedSection}_ExistingStudentsList`
      : `${sscSelectedClass}-${sscSelectedSection}_ExistingStudentsList`
  );

  // Add headers
  worksheet.columns = [
    { header: "Admission No", key: "AdmissionNumber", width: 15 },
    { header: "Admission Date", key: "AdmissionDate", width: 15 },
    ...(board === "INTERMEDIATE"
      ? [{ header: "Course", key: "Course", width: 15 }]
      : []),
    { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
    { header: "Section", key: "Section", width: 10 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Gender", key: "Gender", width: 10 },
    { header: "Father Name", key: "FatherName", width: 20 },
    { header: "Mother Name", key: "MotherName", width: 20 },
    { header: "Phone", key: "Phone", width: 15 },
  ];

  // Add data to worksheet
  processedData.forEach((data) => {
    worksheet.addRow(data);
  });

  // Style headers
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light Blue Header
    };
  });

  // Write and download file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = board === "INTERMEDIATE"
    ? `${interSelectedClass}-${interSelectedSection}_ExistingStudentsList.xlsx`
    : `${sscSelectedClass}-${sscSelectedSection}_ExistingStudentsList.xlsx`;
    link.click();
  });

  handleExportClose();
};


// Export to PDF
const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  if (board === "INTERMEDIATE") {
    doc.text(`${interSelectedClass}-${interSelectedSection} Existing Students List`, 10, 8);
  } else {
    doc.text(`${sscSelectedClass}-${sscSelectedSection} Existing Students List`, 10, 8);
  }

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 14, 16);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 40, 16);

  // Define headers conditionally
  const headers = board === "INTERMEDIATE"
    ? [
        "S.No", "Admission No", "Admission Date", "Course", "Year", "Section",
        "Student Name", "Gender", "Father Name", "Mother Name", "Phone"
      ]
    : [
        "S.No", "Admission No", "Admission Date", "Class", "Section",
        "Student Name", "Gender", "Father Name", "Mother Name", "Phone"
      ];

  // Define body rows
  const bodyData = filteredData.map((row, index) => {
    const rowData = [
      index + 1,
      row.customAdmissionNumber,
      row.admissionDate
    ];

    if (board === "INTERMEDIATE") {
      rowData.push(row.course); // Add course only for INTERMEDIATE
    }

    rowData.push(
      `${row.romanNumberClass}`,
      row.sections,
      `${row.firstName} ${row.lastName}`,
      row.gender,
      `${row.fathersFirstName} ${row.fathersLastName}`,
      `${row.mothersFirstName} ${row.mothersLastName}`,
      row.primaryContact
    );

    return rowData;
  });

  // Render the table
  doc.autoTable({
    startY: 20,
    head: [headers],
    body: bodyData,
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  // Save file
  if (board === "INTERMEDIATE") {
    doc.save(`${interSelectedClass}-${interSelectedSection}_ExistingStudentsList.pdf`);
  } else {
    doc.save(`${sscSelectedClass}-${sscSelectedSection}_ExistingStudentsList.pdf`);
  }

  handleExportClose();
};




const exportToJSON = () => {
  const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(filteredData, null, 2)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  if(board === "INTERMEDIATE") {
    link.download = `${interSelectedClass}-${interSelectedSection}_ExistingStudentsList.json`;
  } else {
    link.download = `${sscSelectedClass}_${sscSelectedSection}_ExistingStudentsList.json`;
  }
  link.click();
  handleExportClose();
};



  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop:"60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          {/* <Typography
            variant="h5"
            sx={{ fontWeight: "bold", mb: 3, textAlign: "center" }}
          >
            Student List
          </Typography> */}
          <Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Existing Student List
                              </Typography>
                            </Box>


          <Box
  display="flex"
 
  mb={3}
  flexWrap="wrap"
>
<TextField
      label="Search by Name Or Mobile No"
      variant="outlined"
      size="small"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      sx={{ marginRight: 2 }}
    />

 
{board === "SSC" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
      <InputLabel id="class-select-label">Select Class</InputLabel>
      <Select
        labelId="class-select-label"
        value={sscSelectedClass}
        // onChange={(e) => setSscSelectedClass(e.target.value)}
         onChange={(e) => {
          const selected = e.target.value;
          setSscSelectedClass(selected);
          // setMode("classSection");
      
          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
        }}
        label="Select Class"
        sx={{ height: 35 }}
      >
        {sscClassOptions.map((cls) => (
          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
        ))}
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
      <InputLabel id="section-select-label">Select Section</InputLabel>
      <Select
        labelId="section-select-label"
        value={sscSelectedSection}
        // onChange={(e) => setSscSelectedSection(e.target.value)}
        onChange={(e) => {
              setSscSelectedSection(e.target.value);
              // setMode("classSection");
            }}
        label="Select Section"
        sx={{ height: 35 }}
        disabled={sscSectionOptions.length === 0}
      >
        {sscSectionOptions.map((section) => (
          <MenuItem key={section} value={section}>{section}</MenuItem>
        ))}
      </Select>
    </FormControl>
  </>
)}


{board === "INTERMEDIATE" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        value={interSelectedClass}
        onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        sx={{ height: 35 }}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
      <InputLabel id="course-type-label">Select Course</InputLabel>
      <Select
        labelId="course-type-label"
        value={selectedCourseType}
        // onChange={(e) => setSelectedCourseType(e.target.value)}
         onChange={(e) => {
          setSelectedCourseType(e.target.value);
          // setMode("classSection");
        }}
        label="Select Course"
        sx={{ height: 35 }}
      >
        {courseOptions.map((course, index) => (
          <MenuItem key={index} value={course}>{course}</MenuItem>
        ))}
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
      <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
      <Select
        labelId="intermediate-section-select-label"
        value={interSelectedSection}
        // onChange={(e) => setInterSelectedSection(e.target.value)}
        onChange={(e) => {
            setInterSelectedSection(e.target.value);
            // setMode("classSection");
          }}
        label="Select Section"
        sx={{ height: 35 }}
      >
        {interSectionOptions.map((section, index) => (
          <MenuItem key={index} value={section}>{section}</MenuItem>
        ))}
      </Select>
    </FormControl>
  </>
)}

{/* <Button
  onClick={() => {
    if (board === "SSC") {
      setSscSelectedClass('');
      setSscSelectedSection('');
    } else if (board === "INTERMEDIATE") {
      setInterSelectedClass('');
      setSelectedCourseType('');
      setInterSelectedSection('');
    }

    setMode("scrolling");

    // ✅ Prevent API call if UserId is missing
    if (UserId && oId) {
      fetchGetAllTableData();
    } else {
      console.warn("Cannot fetch data: Missing UserId or oId");
    }
  }}
  variant="outlined"
  color="primary"
  sx={{ marginLeft: '10px' }}
>
  Fetch OverAll Data
</Button> */}

 {/* {isPrincipal && (
          <FormControl fullWidth style={{ width: "150px" ,marginLeft:'5px'}} size="small">
            <InputLabel>Select Admin</InputLabel>
            <Select
              value={selectedUsers}
              onChange={(e) => setSelectedUsers(e.target.value)}
              label="Select Admin"
            >
              {users.map((user) => (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.userId}-{user.firstName} {user.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )} */}


  <Box sx={{ flexGrow: 1 }} />
 

  
<Grid item xs={3} style={{ display: "flex", justifyContent: "flex-end" }}>
  <Button 
    variant="contained" 
    onClick={handleExportClick}  
    style={{ backgroundColor: '#3C3972', fontWeight: 'bold' }}
    startIcon={<PresentToAllIcon />}  
  >
    Export
  </Button>

  <Menu
    anchorEl={exportAnchorEl}
    open={isExportMenuOpen}
    onClose={handleExportClose}
    sx={{
      "& .MuiPaper-root": {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
      },
    }}
  >
    <MenuItem 
      onClick={exportToExcel}
      sx={{
        color: "#3f51b5",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f0fe",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#00796b' }}>
        <SimCardDownloadIcon />
      </ListItemIcon>
      <ListItemText primary="Excel" sx={{ fontWeight: 'bold', color: '#00796b' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToPDF}
      sx={{
        color: "#d32f2f",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#fdecea",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#d32f2f' }}>
        <PictureAsPdfIcon />
      </ListItemIcon>
      <ListItemText primary="PDF" sx={{ fontWeight: 'bold', color: '#d32f2f' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToJSON}
      sx={{
        color: "#388e3c",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f5e9",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#6a1b9a' }}>
        <FilePresentIcon />
      </ListItemIcon>
      <ListItemText primary="JSON" sx={{ fontWeight: 'bold', color: '#6a1b9a' }} />
    </MenuItem>
  </Menu>
</Grid>
  {/* <Button
  variant="contained"
  sx={{
    backgroundColor: "#4caf50", // Custom green color
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c", // Darker green for hover
    },
  }}
  onClick={() => navigate("/NewAdmissionForm")}
>
  New Admission
</Button> */}

</Box>

<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",

            }}
             className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
  <TableHead  >
    <TableRow >
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" ,backgroundColor: "#fff9c4",fontWeight:'Bold' }}>S.No</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" , textAlign: "center",backgroundColor: "#fff9c4",fontWeight:'Bold'  }}>Admission No</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" , textAlign: "center",backgroundColor: "#fff9c4" ,fontWeight:'Bold' }}>Admission Date</TableCell>
      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" }}>Admission Number</TableCell> */}
      {(board === "INTERMEDIATE" ) && (
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "Bold",
                    }}
                  >
                    Course
                  </TableCell>
                  )}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>Class</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>Section</TableCell>
      
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap",backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'Bold' }}>Name</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap",backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'Bold' }}>Father Name</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap", backgroundColor: "#fff9c4",overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'Bold' }}>Mother Name</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" ,backgroundColor: "#fff9c4" ,fontWeight:'Bold' }}>Mobile No</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'Bold' }}>Gender</TableCell>
   
      <TableCell sx={{ padding: "4px" ,backgroundColor: "#fff9c4", textAlign: "center" ,fontWeight:'Bold' }}>Full Details</TableCell>
    </TableRow>
  </TableHead>
  {loading ? (
    <TableBody>
      <TableRow>
                      <TableCell colSpan={11} style={{ textAlign: "center", padding: "20px" }}>
                        <Box display="flex" flexDirection="column" alignItems="center">
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Data...
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
      {/* <TableRow>
        <TableCell colSpan={13} sx={{ textAlign: "center" }}>
          <CircularProgress size={20} />
        </TableCell>
      </TableRow> */}
    </TableBody>
  ) : filteredData.length === 0 ? (
    <TableBody>
      <TableRow>
        <TableCell colSpan={13} sx={{ textAlign: "center" }}>
          No data found
        </TableCell>
      </TableRow>
    </TableBody>
  ) : (
   <TableBody>
  {filteredData.map((row, index) => (
    <TableRow key={row.admissionNumber} style={{
      backgroundColor: "white",
      transition: "background-color 0.3s",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = "white"; // Default color
    }}>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {index + 1}
      </TableCell>
      {/* <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    display: "flex",
    flexDirection: "column", // Stack items vertically
    justifyContent: "center", // Center the content vertically
    alignItems: "center", // Center the content horizontally
  }}
>
  <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
  <Avatar src={row.passPhoto} alt="Pass Photo" sx={{ width: 25, height: 25, objectFit: "cover" }} />
  <Typography sx={{ marginLeft: "8px" }}> {row.admissionNumber} </Typography>
  </Box>
</TableCell> */}

      <TableCell sx={{borderRight: "1px solid #ddd", padding: "4px", textAlign: "center"  }}>
        {row.customAdmissionNumber}
      </TableCell>
      <TableCell sx={{borderRight: "1px solid #ddd", padding: "4px", textAlign: "center"  }}>
        {row.admissionDate}
      </TableCell>
      {board === "INTERMEDIATE" && (
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.course}
                      </TableCell>
                      )}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
      {row.romanNumberClass}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.sections}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{`${row.firstName} ${row.lastName}`}</TableCell>
      <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "center",
  }}
>
  {(row.fathersFirstName || row.fathersLastName)
    ? `${row.fathersFirstName || ""} ${row.fathersLastName || ""}`.trim()
    : "NA"}
</TableCell>

      <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
  }}
>
  {(row.mothersFirstName || row.mothersLastName)
    ? `${row.mothersFirstName || ""} ${row.mothersLastName || ""}`.trim()
    : "NA"}
</TableCell>

      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.primaryContact}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.gender}
      </TableCell>
      
      <TableCell
sx={{ borderRight: "1px solid #ddd", padding: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}
>
  <Button
    type="button"
    onClick={() =>
      navigate(`/StudentDetailView/${row.studentId}`)
      //   , {
      //   state: { student: row },
      // })
    }
    sx={{
      backgroundColor: "#1976d2",
      color: "white",
      fontSize: "0.6rem", // Reduces the font size
      // padding: "5px 10px",  // Reduces the padding
      height: "25px",       // Reduces the height
      "&:hover": {
        backgroundColor: "#1565c0",
      },
    }}
  >
    View
  </Button>
</TableCell>

    </TableRow>
  ))}
</TableBody>


  )}
</Table>

          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ExistingStudentsList;